import React, { CSSProperties, FunctionComponent, useEffect } from 'react'
import c3, { PrimitiveArray } from 'c3'
import './DonutChart.css'

interface Props {
  id: string
  style?: CSSProperties
  data: Array<[string, ...PrimitiveArray]>
  // title is rendered in the centre of the donut (e.g. the total).
  title?: string
}

const availableColors = ['#26AA27', '#8EC641', '#33C1AF', '#F0C002']

export const DonutChart: FunctionComponent<Props> = props => {
  useEffect(() => {
    const colors: any = {}
    props.data.forEach((d, i) => {
      colors[d[0]] = availableColors[i]
    })
    c3.generate({
      bindto: '#' + props.id,
      data: {
        columns: props.data,
        type: 'donut',
        colors: colors,
      },
      donut: {
        title: props.title,
      },
      legend: {
        show: false,
      },
    })
  }, [props.data, props.id, props.title])

  // eslint-disable-next-line react/forbid-dom-props -- pass-through component style prop
  return <div id={props.id} style={props.style} />
}
